import { NotificationManager } from 'react-notifications';
import {
  getAllClientsRequest,
  getAllClientsStaffRequest,
  getAllIssuerClientsStaffRequest,
  toggleClientStatusRequest,
  _getAllClients,
  resetClientStaffPasswordRequest,
  logoutClientStaffRequest,
  toggleClientStaffStatusRequest
} from 'src/api/ClientManagerRequest';
import { requestWrapper } from 'src/utils/utils';
import { GETCLIENTS_SUCCESS, GET_CLIENTS_STAFFS } from '../types';
import { checkRequestError } from '.';

// v1: Deprecated
export const getClients = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getAllClients();
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETCLIENTS_SUCCESS, payload: data.content });
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

// V2
export const getClientsAction = (filterObj) => async (dispatch) => {
  try {
    const { data } = await getAllClientsRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GETCLIENTS_SUCCESS, payload: data.content.data.all });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    // NotificationManager.info(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

// V2
export const toggleClientStatusAction = (id, payload) => async (dispatch) => {
  try {
    const { data } = await toggleClientStatusRequest(
      id,
      requestWrapper(payload)
    );
    checkRequestError(data);

    dispatch(getClientsAction());
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const getClientsStaffAction = (filterObj, isAdmin) => async (
  dispatch
) => {
  try {
    const { data } = isAdmin
      ? await getAllClientsStaffRequest(filterObj)
      : await getAllIssuerClientsStaffRequest();
    checkRequestError(data);

    dispatch({
      type: GET_CLIENTS_STAFFS,
      payload: data.content.data?.all || []
    });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    // NotificationManager.info(error.message, 'Error');
    console.log('client staff error ', error);
    return { message: error.message, status: 0 };
  }
};

export const resetClientStaffPasswordAction = (filterObj, isAdmin) => async (
  dispatch
) => {
  try {
    const { data } = await resetClientStaffPasswordRequest(filterObj);
    checkRequestError(data);

    NotificationManager.info(data.success.message, 'Info');
    const filter = { issuerID: filterObj?.issuerID };
    dispatch(getClientsStaffAction(filter, isAdmin));
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const logoutClientStaffAction = (filterObj, isAdmin) => async (
  dispatch
) => {
  try {
    const { data } = await logoutClientStaffRequest(filterObj);
    checkRequestError(data);

    NotificationManager.info(data.success.message, 'Info');
    const filter = { issuerID: filterObj?.issuerID };
    dispatch(getClientsStaffAction(filter, isAdmin));
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const activateClientStaffStatusAction = (
  filterObj,
  isAdmin,
  payload
) => async (dispatch) => {
  try {
    const { issuerStaffID } = filterObj;
    const { data } = await toggleClientStaffStatusRequest(
      issuerStaffID,
      payload
    );
    checkRequestError(data);

    NotificationManager.info(data.success.message, 'Info');
    const filter = { issuerID: filterObj?.issuerID };
    dispatch(getClientsStaffAction(filter, isAdmin));
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};
